<script lang="ts" setup>
import type { IAppProps } from '@/interfaces/IAppProps'
import { ref } from 'vue'
import { balanceApi } from '@/apis/balanceApi'
import { useEntryProps } from '@/composable/useDatasetProps'
import { useGlobalStore } from '@/stores/globalStore'

const globalStore = useGlobalStore()

const balance = ref<string>('')

const { loginName } = useEntryProps<IAppProps>()

const reloadBalance = async () => {
    const balanceText = document.getElementById('balance-txt')
    balanceText?.classList.remove('blink')

    const refreshIcon = document.getElementById('icon-refresh')
    refreshIcon?.classList.toggle('icon-spin')

    balance.value = await balanceApi.get()
    refreshIcon?.classList.toggle('icon-spin')
    balanceText?.classList.toggle('blink')
}
const autoReloadBalance = async () => {
    setInterval(async () => {
        const newBalance = await balanceApi.get()
        if (balance.value !== newBalance) {
            balance.value = newBalance
        }
    }, 30000)
};

(async () => {
    const newBalance = await balanceApi.get()
    balance.value = newBalance
    globalStore.setBalance(newBalance)
    await autoReloadBalance()
})()
</script>

<template>
    <div class="user-info">
        <div class="login-name">
            <img alt="user-icon" class="icon-user" src="../../assets/images/icon_user.svg">
            <span class="username-txt">{{ loginName }}</span>
        </div>
        <div class="balance balance-refresh" @click="reloadBalance()">
            <span id="balance-txt" class="balance-txt">
                <span id="balance">{{ balance }}</span>
            </span>
            <img id="icon-refresh" alt="reload" class="icon-refresh" src="../../assets/images/icon_reload.svg">
        </div>
    </div>
</template>

<style lang="scss">
.user-info {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 16px;

    .login-name,
    .balance {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
    }

    .balance {
        cursor: pointer;
    }
}

.username-txt {
    display: inline-block;
    color: #ffffff;
    font-weight: bold;
}

.icon-user {
    width: 16px;
}

.balance-refresh:hover span,
.balance-refresh:hover img {
    color: #ffffff;
}

.balance-refresh.refresh-loading:hover span,
.balance-refresh.refresh-loading:hover img {
    color: #ffffff;
}

.balance-refresh .icon-refresh {
    width: 16px;
}

.balance-txt {
    display: inline-block;
    color: #ffffff;
    font-weight: bold;
}

.icon-spin {
    display: inline-block;
    animation: spin 2s infinite linear;
}

.blink {
    animation: blink 1s;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(359deg);
    }
}

@keyframes blink {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>
